module.exports = __webpack_public_path__ + "img/topup_grey_border.41ff6662.svg";